import EtiquetaSelection from "./etiquetaSelection";
import TagEditor from "./tagEditor";
import TemplateSelection from "./templateSelection";

function Steps(props: {
  setActiveStep: (step: number) => void;
  activeStep: number;
  produtoSelecionado: string;
  handleProdutoSelecionado: (sku: string) => void;
  handleSelectTemplate: (template: string) => void;
  setOpenModalMinhasEtiquetas: (open: boolean) => void;
  setProdutoSelecionado: (sku: string) => void;
}) {
  return (
    <>
      {props.activeStep === 1 && (
        <EtiquetaSelection
          handleProdutoSelecionado={props.handleProdutoSelecionado}
          setActiveStep={props.setActiveStep}
          setProdutoSelecionado={props.setProdutoSelecionado}
          setOpenModalMinhasEtiquetas={props.setOpenModalMinhasEtiquetas}
        />
      )}

      {props.produtoSelecionado !== "" && props.activeStep === 2 && (
        <TemplateSelection handleSelectedTemplate={props.handleSelectTemplate} />
      )}

      {props.produtoSelecionado !== "" && props.activeStep === 3 && (
        <TagEditor
          setOpenModalMinhasEtiquetas={props.setOpenModalMinhasEtiquetas}
          setActiveStep={props.setActiveStep}
        />
      )}
    </>
  );
}

export default Steps;
